// extracted by mini-css-extract-plugin
module.exports = {"root":"TermsOfService_root__Z8ZdW","lastUpdated":"TermsOfService_lastUpdated__3biGA"};